import {
  Box,
  Stack,
  Modal,
  Button,
  Typography,
  IconButton,
  Divider,
} from '@mui/material';
import storeConnector from '@src/store/storeConnector';
import { ControlModes } from '@src/types/Stacks';
import CloseIcon from '@mui/icons-material/Close';
import TemplatesFields from './TemplatesFields';
import { Dispatch, SetStateAction } from 'react';
import { useFormContext } from 'react-hook-form';
import { FormValues } from './TemplatesCard';
import { templatesViewSx } from '@src/components/_shared/sxStyles/Config/templates';
import useAlias from '@src/hooks/useAlias';
import FormattedAlias from '@components/_shared/Translations/FormattedAlias';

interface TemplatesFullConfigchProps {
  controlMode: ControlModes;
  setOpen: Dispatch<SetStateAction<boolean>>;
  onSubmit: (formValues: FormValues) => void;
}

function TemplatesFullConfigch({
  controlMode,
  setOpen,
  onSubmit,
}: TemplatesFullConfigchProps) {
  const alias = useAlias();
  const { handleSubmit } = useFormContext<FormValues>();

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Modal
      open
      onClose={handleClose}
      aria-labelledby='child-modal-title'
      aria-describedby='child-modal-description'
    >
      <Box sx={templatesViewSx.fullConfig.wrapper}>
        <Box>
          <Box sx={templatesViewSx.fullConfig.header}>
            <Typography variant='h5' id='child-modal-title'>
              {alias('Edit {name} Full Config', { name: controlMode.name })}
            </Typography>
            <IconButton
              onClick={handleClose}
              sx={templatesViewSx.fullConfig.header.closeButton}
            >
              <CloseIcon sx={{ fontSize: '2rem' }} />
            </IconButton>
          </Box>
          <Divider sx={templatesViewSx.fullConfig.header.divider} />
        </Box>

        <Box sx={templatesViewSx.fullConfig.fieldsSection}>
          {controlMode.sections.map((section, index: number) => (
            <Stack
              sx={templatesViewSx.fullConfig.fieldsSection.fieldsWrapper}
              key={index}
              spacing={2}
            >
              <Typography variant='h6'>{section.uiLabel}</Typography>

              <TemplatesFields key={index} inputFields={section.fields} />
            </Stack>
          ))}
        </Box>

        <Box sx={templatesViewSx.fullConfig.footer}>
          <Button
            variant='contained'
            color='primary'
            size='small'
            onClick={handleSubmit(onSubmit)}
          >
            <FormattedAlias id='Save Changes' />
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}

export default storeConnector(TemplatesFullConfigch, {
  config: ['siteMeta'],
});
